// extracted by mini-css-extract-plugin
export default {"btn":"SecondaryButton_btn__C9NTx"};